export const Errors = {
  MOBILE_EXISTS: "کاربری بااین شماره موبایل ثبت نام شده است",
  AUTH_INVALID: "شماره موبایل یا رمز عبور اشتباه است",
  MOBILE_INVALID: "فرمت شماره موبایل اشتباه است",
  OTP_INVALID: "کد تایید نا معتبر هست",
  CONFIRMATION_PASSWORD: "رمز های عبور وارد شده تطابق ندارد",
  OTP_EXPIRED: "کد تایید نا معتبر هست",
  USER_NOT_FOUND: "کاربری با این مشخصات ثبت نام نشده است",
  RATE_INVALID: "امتیاز وارد شده نا معتبر هست",
  CONSULTING_MINUTES_INVALID: "زمان مشاوره نامعتبر هست",
  INVALID_ADDRESS: "کاربر گرامی لطفا آدرس خود را باجزئیات کامل وارد کنید",
  USER_INACTIVE: "",
  SEND_NOT_FOUND: "نوع ارسال خود را مشخص کنید",
  PROVINCE_NOT_FOUND: "استان وارد شده یافت نشد",
};
